import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

// services
import { AuthHttpInterceptor } from '../auth/auth.http.interceptor';
import { SessionsService } from './sessions.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class SessionsServiceModule {
  static forRoot(): ModuleWithProviders<SessionsServiceModule> {
    return {
      ngModule: SessionsServiceModule,
      providers: [SessionsService],
    };
  }
}
